import $ from 'jquery'
import _ from 'underscore'
import Backbone from 'backbone'
import { Router } from './router'

import LocomotiveScroll from 'locomotive-scroll'
// const Cursor = require('./cursor');

import Cursor from './cursor'

// console.log(Cursor)
// console.log(Cursor2)

window.LocomotiveScroll = LocomotiveScroll
window.Cursor = Cursor

require('./utils');

// import ReviewsTemplate from './templates/reviews.html'
// import ExtBookTemplate from './templates/external-book.html'
// import PrincipleCastTemplate from './templates/cast.html'


window.Site = window.Site || {
      baseURL: AC.baseurl + '/',
      isRetina: window.devicePixelRatio > 1,
      root: AC.root,
      debug: AC.debug,
      routesHit: 0,
      draggable: new Array()
}

window.a = 0;

// window.reviewsTemplate = _.template(ReviewsTemplate)
// window.bookTemplate = _.template(ExtBookTemplate)
// window.castTemplate = _.template(PrincipleCastTemplate)

window.yt_players = []

window.onYouTubeIframeAPIReady = () => {
	$('body').trigger('onYouTubeIframeAPIReady')
}

window.initMap = () => {
      $('body').trigger('initMap')
}

 
Router.initialize();